import { TMetaData, TVisitorsDataTable } from "types/analytics.types";
import { IndexContainer, RowContainer, TableContainer } from "./index.styles";
import UI from "@mile-meeting/mile-ui";
const VisitorsTable = ({
  metadata,
  data,
  page,
}: {
  metadata?: TMetaData[];
  data?: TVisitorsDataTable[];
  page: number;
}) => {
  const columns = metadata?.map((meta) => meta.name);
  const columnsNameList = metadata?.map((meta) => meta.columnName);

  return (
    <TableContainer>
      <IndexContainer>
        <div className="row">
          <div className="item">
            <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
              Id
            </UI.Typography>
          </div>
          {columns?.map((column, index) => (
            <div className="item" key={index}>
              <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
                {column}
              </UI.Typography>
            </div>
          ))}
        </div>
      </IndexContainer>
      {!data ||
        (data?.length === 0 && (
          <RowContainer style={{ gap: 8, width: "100%", boxSizing: "border-box" }}>
            <UI.Icon name="removeCircle" size={24} color="var(--alias-color-label-alternative)" />
            <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
              조회 결과가 없습니다.
            </UI.Typography>
          </RowContainer>
        ))}
      {data &&
        data.length > 0 &&
        data?.map((row, index) => (
          <RowContainer>
            <div className="row">
              <div className="item">
                <UI.Typography type="label01" fontStyle="regular" color="var(--alias-color-label-normal)">
                  {(page - 1) * 10 + index + 1}
                </UI.Typography>
              </div>
              {columnsNameList?.map((column) => (
                <div className="item">
                  <UI.ToolTip
                    position={{ top: "-120%", left: 0 }}
                    type="white"
                    text={`${
                      row[column as keyof TVisitorsDataTable]
                        ? row[column as keyof TVisitorsDataTable]?.toString()
                        : row[column as keyof TVisitorsDataTable] === false
                          ? "false"
                          : "-"
                    }`}
                  >
                    <UI.Typography
                      type="label01"
                      fontStyle="regular"
                      color="var(--alias-color-label-normal)"
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        width: 160,
                      }}
                    >
                      {row[column as keyof TVisitorsDataTable]
                        ? row[column as keyof TVisitorsDataTable]?.toString()
                        : row[column as keyof TVisitorsDataTable] === false
                          ? "false"
                          : "-"}
                    </UI.Typography>
                  </UI.ToolTip>
                </div>
              ))}
            </div>
          </RowContainer>
        ))}
    </TableContainer>
  );
};

export default VisitorsTable;
